const HIGH_VALUE_FEATURES = new Set([
  'metabolism',
  'metabolism_detailed',
  'advanced_plans',
  'nutrition',
  'labs',
  'specialists',
  'ai_recommendations',
  'personalized_notifications'
]);

/**
 * Human video AND OpenAI specialist consults: Premium only.
 * Trial / free never opens a specialist chat or Twilio room as a patient.
 */
export const PREMIUM_ONLY_FEATURES = new Set(['specialists']);

export function resolveCommercialStage({
  isAuthenticated,
  hasActiveSubscription,
  hasActiveTrial
}) {
  if (!isAuthenticated) return 'visitor';
  if (hasActiveSubscription) return 'premium';
  if (hasActiveTrial) return 'free_trial';
  return 'free';
}

export function getPotentialProgress(stage) {
  if (stage === 'premium') return 100;
  if (stage === 'free_trial') return 70;
  return 30;
}

export function isHighValueFeature(featureName) {
  return HIGH_VALUE_FEATURES.has(String(featureName || '').toLowerCase());
}

export function isPremiumOnlyFeature(featureName) {
  return PREMIUM_ONLY_FEATURES.has(String(featureName || '').toLowerCase());
}

export function featureForPath(pathname) {
  const path = String(pathname || '').toLowerCase().replace(/\/+$/, '') || '/';

  if (path.startsWith('/premium/')) return 'advanced_plans';
  if (path.startsWith('/dashboard/metabolismo')) return 'metabolism';
  if (path.startsWith('/dashboard/nutricion')) return 'nutrition';
  if (path.startsWith('/dashboard/especialistas')) return 'specialists';
  if (path.startsWith('/dashboard/planes')) return 'advanced_plans';
  if (path.startsWith('/herramientas/laboratorios')) return 'labs';

  // Admin console must never be gated as a commercial feature.
  if (path.startsWith('/dashboard/admin')) {
    return null;
  }

  if (
    path.startsWith('/dashboard/exercise-live') ||
    path.startsWith('/dashboard/triage') ||
    path.startsWith('/dashboard/bionexos') ||
    path.startsWith('/dashboard/neuro-reset') ||
    // Waitlist page is visible; Twilio still requires Premium at the API.
    path.startsWith('/herramientas/consultas')
  ) {
    return null;
  }

  if (path.startsWith('/dashboard/')) return 'advanced_plans';
  return null;
}

export function checkPotentialAccess(featureName, commercialState) {
  const feature = String(featureName || '').toLowerCase();
  const state = commercialState || {};
  const stage = state.stage || 'visitor';

  if (!isHighValueFeature(feature)) {
    return true;
  }

  if (isPremiumOnlyFeature(feature)) {
    return stage === 'premium';
  }

  if (stage === 'premium' || stage === 'free_trial') {
    return true;
  }

  return false;
}
